/*
  Création de l'objet document (utilisé par tous les composants document...)
 */
const UPLOAD_OK = 0,
  UPLOADING = 1,
  UPLOAD_ERROR = 3

export function createDocument(document, root) {
  return {
    document: document,
    $root: root,
    id: document.id,
    index: -1,
    label: root.$t('document.labelUndefined'),
    statusLabel: root.$t('document.status.undefined'),
    uploadStatus: UPLOAD_OK,
    uploadError: null,
    incomplete: document.document ? document.document.status === 'INCOMPLETE' : false,
    errors: document.errors,
    downloadName: root.$t('document.status.undefined') + '.pdf',

    isUploadError: function () {
      return this.uploadStatus === UPLOAD_ERROR
    },
    isUploading: function () {
      return this.uploadStatus === UPLOADING
    },

    setUploadOk: function () {
      this.uploadStatus = UPLOAD_OK
      this.uploadError = null
    },
    setUploading: function () {
      this.uploadStatus = UPLOADING
      this.uploadError = null
    },
    setUploadError: function (errorUpload) {
      this.uploadStatus = UPLOAD_ERROR
      this.uploadError = errorUpload
    },

    getURL: function () {
      //return config.host + 'downloadAssoc.php?i=' + this.id + '&n='+this.downloadName;
    },

    defineMissing: function (index) {
      this.index = index

      // Définit le label du document
      if (this.document.documentType) {
        this.label = this.document.documentType.name
        if (this.document.name) {
          this.label += ' ' + this.document.name
        }
      }
      this.statusLabel = this.$root.$t('document.status.missing')

      return this
    },

    defineDocument: function (index) {
      this.index = index
      let status = this.$root.$t('document.status.undefined')
      let doc = this.document.document

      if (doc) {
        this.downloadName = doc.downloadName

        if (doc.documentType) {
          this.label = doc.documentType.name
          if (doc.name) {
            this.label += ' ' + doc.name
          }
        }

        if (doc.validatedAt) {
          if (doc.documentSignFiles && doc.documentSignFiles.length > 0) {
            status = ''
            let signFileStatuses = doc.documentSignFiles[0].documentSignFileStatuses
            for (let i = 0; i < signFileStatuses.length; i++) {
              let signFileStatus = signFileStatuses[i]
              let doc_status = ''

              switch (signFileStatus.status) {
                case 'PENDING':
                  doc_status = this.$root.$t(
                    'document.status.waitingSignature' + (signFileStatus.documentSigner.validator ? '' : '_validator'),
                  )
                  break
                case 'SIGNED':
                case 'SIGNED_FULL':
                  doc_status = this.$root.$t(
                    'document.status.signed' + (signFileStatus.documentSigner.validator ? '' : '_validator'),
                  )
                  break
                case 'PROCESSING':
                  doc_status = this.$root.$t(
                    'document.status.inSigning' + (signFileStatus.documentSigner.validator ? '' : '_validator'),
                  )
                  break
                case 'CANCELLED':
                  doc_status = this.$root.$t('document.status.cancel')
                  break
                case 'ERROR':
                  doc_status = this.$root.$t('document.status.error')
                  break
                default:
                  doc_status = this.$root.$t('document.status.undefined')
              }

              status += doc_status
              if (signFileStatus.signedAt) {
                let date = this.$root.$d(new Date(signFileStatus.signedAt), 'datetime_short')
                status += ' ' + this.$root.$t('document.status.date', { date: date })
              }
              if (signFileStatus.documentSigner) {
                status +=
                  ' ' +
                  this.$root.$t('document.status.by', {
                    par: signFileStatus.documentSigner.firstname + ' ' + signFileStatus.documentSigner.lastname,
                  })
              }
              status += '<br>'
            }
          } else {
            let date = this.$root.$d(new Date(doc.validatedAt), 'date_short')
            status = this.$root.$t('document.status.VALIDATED', { date: date })
          }
        } else {
          status = this.$root.$t('document.status.' + doc.status)
        }

        this.errors = doc.errors
      }

      this.statusLabel = status
      return this
    },
  }
}
